import { API_URLS } from '@services/apiRoutes'
import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type {
  ApprovalWorkflowBonusRequestProps,
  EditBonusRequestProps,
  GetBonusRequestProps,
  ReleasePreviousBonusRequestProps,
  ReversePreviousBonusRequestProps
} from './types'

import * as apiFunction from '@services/apiFunctions'

export const reversePreviewBonus = async (payload: ReleasePreviousBonusRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${payload.filiCode}/bonificacao/reverter-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const releasePreviewBonus = async (payload: ReleasePreviousBonusRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${payload.filiCode}/bonificacao/liberar-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const reverseWorkflowBonus = async (payload: ReversePreviousBonusRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.consumption}/${payload.filiCode}/bonificacao/restaurar-previa/dt-competencia/${payload.competenceDate}`,
    method: 'DELETE'
  })
}

export const approvalWorkflowBonus = async (payload: ApprovalWorkflowBonusRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.consumption}/${payload.filiCode}/bonificacao/envio-previa/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const editBonus = async ({ routeParams, bodyParams }: EditBonusRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/bonificacao/detalhe-previa/dt-competencia/${routeParams.competenceDate}`,
    method: 'PUT',
    body
  })
}

export const getBonus = async (payload: GetBonusRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.consumption}/${payload.filiCode}/bonificacao/detalhe-previa/dt-competencia/${payload.competenceDate}`,
    method: 'GET'
  })
}
